module.exports = __webpack_public_path__ + "img/29.e960fa5b.png";